(function() { 'use strict';
    angular.module('mso.registration')
        .factory('RegisterDataAccessService', RegisterDataAccessService);

    RegisterDataAccessService.$inject = ['$resource','Config','$q'];
    function RegisterDataAccessService($resource, Config, $q) {
        var RegisterApi = $resource(Config.apiBaseHref + "/register", null);
        var FindFirmApi = $resource(Config.apiBaseHref + "/register/firm", null);
        var FirmsApi = $resource(Config.apiBaseHref + '/register?firmType=:firmType', {}, {'get': {method: 'GET', isArray: true}});
        var MortgageClubsApi = $resource(Config.apiBaseHref + '/register/payment-routes', null, {'get': {method: 'GET', isArray: true}});
        var GetRolesApi = $resource(Config.apiBaseHref + "/register/roles", null, {'get': {method: 'GET', isArray: true}});
        var GetRoleCombinationsApi = $resource(Config.apiBaseHref + "/register/role-combinations", null, {'get': {method: 'GET', isArray: true}});
        var ResourceActionApi = $resource(Config.apiBaseHref + "/register/resource-action", null);

        return {
            register: register,
            verifyFirm: verifyFirm,
            getAllMortgageClubs: getAllMortgageClubs,
            getAllTradingAddressesForFirm: getAllTradingAddressesForFirm,
            getRoles: getRoles,
            getValidRoleCombinations: getValidRoleCombinations,
            checkResourceAction: checkResourceAction,
            getPrincipalFirms: getPrincipalFirms
        };

        function register(registerIntermediary) {

            var deferred = $q.defer();
            RegisterApi.save(registerIntermediary).$promise
                .then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function checkResourceAction(roles, resource, action) {
            // Checks whether access is granted to an action against a resource given the selected roles
            var deferred = $q.defer();
            ResourceActionApi.get({roles: roles, resource: resource, action: action}).$promise
                .then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function verifyFirm(fcaNumber) {

            var deferred = $q.defer();
            FindFirmApi.get({fcaNumber: fcaNumber}).$promise
                .then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function getPrincipalFirms(firmType){
            // Returns all the Principal Firms
            var deferred = $q.defer();
            FirmsApi.get({firmType: firmType}).$promise.then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }

        function getAllMortgageClubs() {

            var deferred = $q.defer();
            MortgageClubsApi.get({type: 1}).$promise
                .then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function getAllTradingAddressesForFirm(firmId) {
            var TradingAddressesApi = $resource(Config.apiBaseHref + '/register/firms/' + firmId + '/trading-addresses', null);
            // {firmId: firmId}
            var deferred = $q.defer();
            TradingAddressesApi.get().$promise
                .then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function getRoles() {

            var deferred = $q.defer();
            GetRolesApi.get().$promise
                .then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function getValidRoleCombinations() {

            var deferred = $q.defer();
            GetRoleCombinationsApi.get().$promise
                .then(function (data) {
                    deferred.resolve(data);
                },
                function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }
    }
})();
